<template>
  <span></span>
</template>

<script>
  import Api from '@/api/Api';
  //  import HelperRole from "@/helper/HelperRole";
  import Helper from "@/helper/Helper";
  import SettingsContainer from '@/helper/SettingsContainer';

  export default {
    name: 'SettingSetter',
    mounted() {
      const modul = this;
//      if (localStorage.getItem("accesstoken")) {
//        modul.accesstoken = localStorage.getItem("accesstoken");
//      }
//      if (modul.delay > 0) {
//        modul.cdelay = this.delay
//      }
      modul.getSettings();
      modul.$eventBus.$on('SettingSetter', this.SettingSetterEventHandler);
    },
    beforeDestroy() {
      const modul = this;
      modul.$eventBus.$off('SettingSetter');
      clearInterval(this.timer);
    },
    data() {
      return {
        accesstoken: "",
      };
    },
    props: {},
    watch: {
      accesstoken: function (newLang, oldLang) {
      }
    },
    methods: {
      SettingSetterEventHandler(o){
        const modul = this;
        modul.getSettings();
      },
      getSettings(){
        const modul = this;
        Api.getSettings({}).then(function (res) {
          if (res && res.result) {
            const arrRes = (Array.isArray(res.data)) ? Array.from(res.data) : [];
            SettingsContainer.setSettings(arrRes);
            Helper.updateSettings();
          }
        }, function (res) {

        });

      },
    }
  };
</script>

<style>
  .cursor {
    cursor: pointer;
  }
</style>
